/*
  DEV-PRODUCT-CARD-COLOR-SWATCHES-001
  Expansion for the product-card "+N" colour overflow control.

  Deliberately tiny and delegated: one listener on document, so cards inserted
  later by collection filtering, sorting, pagination, predictive search or a
  Shopify section re-render work with no per-card initialisation and therefore
  no duplicate initialisation. It does not duplicate <grid-swatch>: colour
  selection, variant state and media swapping stay entirely in the theme's own
  controller. This only toggles a presentation class on the holder.

  The control itself is correct without JavaScript - Liquid renders both the
  desktop and mobile counts and CSS picks the right one at the same 990px
  breakpoint that caps the visible dots. JS only adds the expansion.
*/
(function () {
  if (window.__definexSwatchMore) return;
  window.__definexSwatchMore = true;

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var button = target.closest('[data-swatch-more]');
    if (!button) return;

    event.preventDefault();

    var holder = button.closest('.product-item__swatches__holder');
    if (!holder) return;

    holder.classList.add('is-expanded');
    button.setAttribute('aria-expanded', 'true');
    button.hidden = true;
  });

  /* --------------------------------------------------------------
     In-card colour selection (merchant decision, FINAL-QA).

     Progressive enhancement: the swatch stays a real <a> with a valid
     single-?variant= PDP href, so with JavaScript unavailable it still
     navigates to the right variant. With JS, we intercept and select in
     place instead.

     No new media layer and no fetch: the card already server-renders one
     .product-item__bg__inner overlay per non-default colour, keyed by
     data-variant-title, which matches the swatch's own
     data-swatch-variant-name exactly. The default colour is the base
     .product-item__bg[data-product-image-default] underneath. Selecting a
     colour just activates the matching overlay, so srcset/sizes/width/
     height/alt and lazy loading are all the theme's own.

     Size is never touched: this only moves colour state and links.
  -------------------------------------------------------------- */
  var selectedSwatches = new WeakMap();
  function selectColour(card, swatch) {
    selectedSwatches.set(card, swatch);
    var wanted = (swatch.getAttribute('data-swatch-variant-name') || '').replace(/"/g, "'");
    var imageId = swatch.getAttribute('data-card-swatch-image-id') || '';
    var colourGroup = swatch.getAttribute('data-card-swatch-colour-group') || '';
    var overlays = card.querySelectorAll('.product-item__bg__inner');
    var matched = false;

    for (var i = 0; i < overlays.length; i++) {
      /* Three keys, most specific first. The image id is exact but only exists
         when the variant actually carries a featured_image; 6 products in this
         catalogue assign none, and their overlays are resolved from the media
         alt colour convention instead, so those are matched by colour group.
         The variant title stays as the legacy key for markup rendered before
         either attribute existed. */
      var isMatch = imageId && overlays[i].getAttribute('data-card-image-id')
        ? overlays[i].getAttribute('data-card-image-id') === imageId
        : colourGroup && overlays[i].getAttribute('data-card-colour-group')
          ? overlays[i].getAttribute('data-card-colour-group') === colourGroup
          : overlays[i].getAttribute('data-variant-title') === wanted;
      /* is-visible is the theme's OWN overlay mechanism (assets/theme.css
           .product-item__bg__inner.is-visible, plus the :has() rule that hides the
           base figure). Reusing it means no competing CSS and no specificity war. */
        overlays[i].classList.toggle('is-visible', isMatch);
      if (isMatch) matched = true;
    }
    /* no overlay for this colour means it is the default image, which is the
       base layer - leaving every overlay inactive reveals it. A colour with no
       dedicated media simply keeps whatever is already showing. */
    card.classList.toggle('has-selected-swatch-media', matched);
    syncTouchMedia(card, swatch, imageId, matched);

    /* Base figure visibility is now driven by ONE explicit card-root state,
       .has-selected-swatch-media, not by incidental lazy-image/AOS lifecycle
       classes. See assets/collections.css for the single scoped rule.
       aos-animate is still restored on the default path only, because a figure
       that has never been AOS-animated sits at the pre-animate opacity 0.001
       (assets/theme.css:1071) and would otherwise stay invisible with no overlay
       to cover it. is-loading is never stripped - it belongs to the theme's own
       lazy-image lifecycle. */
    var baseFigure = card.querySelector('.product-item__bg > figure');
    if (baseFigure && !matched) {
      baseFigure.classList.add('aos-animate');
    }

    var swatches = card.querySelectorAll('.swatch__button');
    for (var j = 0; j < swatches.length; j++) {
      var on = swatches[j] === swatch;
      swatches[j].classList.toggle('is-selected', on);
      swatches[j].setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    var href = (swatch.querySelector('.swatch__link') || {}).getAttribute
      ? swatch.querySelector('.swatch__link').getAttribute('href')
      : null;
    if (href) {
      var links = card.querySelectorAll('a.product-link');
      for (var k = 0; k < links.length; k++) {
        links[k].setAttribute('href', href);
        if (links[k].hasAttribute('data-product-link')) {
          links[k].setAttribute('data-product-link', href);
        }
      }
    }

    var name = swatch.getAttribute('data-tooltip') || '';
    var live = card.querySelector('[data-dfx-colour-live]');
    if (live && name) live.textContent = name;
  }

  // The touch hover layer is ABOVE the colour overlays. Keep its existing
  // scroller/controller, but expose only verified frames of the chosen colour.
  // No matching frame: the selected overlay/base owns the photo instead.
  function syncTouchMedia(card, swatch, imageId, matchedOverlay) {
    if (!hoverlessPointer()) return;
    var group = swatch.getAttribute('data-card-swatch-colour-group') || '';
    var frames = card.querySelectorAll('[data-hover-slide-touch]');
    var count = 0;
    var focusFrame = null;
    for (var f = 0; f < frames.length; f++) {
      if (imageId && frames[f].getAttribute('data-card-media-id') === imageId) {
        focusFrame = frames[f];
        break;
      }
    }
    // Open on the merchant's focused photo. If the capped gallery omits it,
    // the verified overlay owns the photo instead of showing another pose.
    if (focusFrame && frames.length && focusFrame !== frames[0]) {
      focusFrame.parentNode.insertBefore(focusFrame, frames[0]);
    }
    for (var i = 0; i < frames.length; i++) {
      var sameImage = !!imageId && frames[i].getAttribute('data-card-media-id') === imageId;
      var sameGroup = !!group && frames[i].getAttribute('data-card-colour-group') === group;
      var visible = (sameImage || sameGroup) && (!imageId || !!focusFrame);
      frames[i].toggleAttribute('data-card-colour-hidden', !visible);
      if (visible) count++;
    }
    card.classList.add('has-card-swatch-selection');
    card.classList.toggle('has-card-colour-frames', count > 0);
    card.classList.toggle('has-single-card-colour-frame', count === 1);

    // A deduplicated overlay may be absent because the base already has this
    // image. Compare image paths, not resized CDN query strings or variant size.
    var base = card.querySelector('.product-item__bg > figure img');
    var source = swatch.getAttribute('data-swatch-image');
    var baseMatches = false;
    if (base && source) {
      try {
        baseMatches = new URL(base.currentSrc || base.src, document.baseURI).pathname ===
          new URL(source, document.baseURI).pathname;
      } catch (error) { /* Invalid media URL is not a verified match. */ }
    }
    var notice = card.querySelector('[data-image-unavailable-notice]');
    if (notice) notice.hidden = matchedOverlay || baseMatches || count > 0;
    card.dispatchEvent(new CustomEvent('theme:card:colour-selected', {bubbles: true}));
  }

  /* --------------------------------------------------------------
     DEV-MOBILE-COLLECTION-SWATCH-STABILIZATION-003
     Hover is a DESKTOP preview. It must not sit in the activation path on a
     touch screen.

     The theme's own GridSwatch binds, per swatch button:
       mouseenter -> showVariantImage   (swaps the card photo)
       click      -> selectSwatch
     and <tooltip-component> - which IS that same button - binds its own
     mouseenter/mouseleave to show a tooltip. So the tap target carries two
     hover-driven CONTENT changes. That is the documented trigger for WebKit's
     touch-to-mouse emulation withholding the first click: tap 1 is delivered
     as the hover (photo preview + tooltip), and only tap 2 arrives as a click.
     That is exactly the merchant's report - first tap does nothing visible or
     changes only the image, second tap selects.

     Rather than add a competing touch controller, the hover-only path is
     gated off where hover does not physically exist. A capture-phase listener
     on document runs BEFORE the per-button handlers (mouseenter does not
     bubble, but it does propagate through the capture phase to its target),
     so stopImmediatePropagation() here prevents GridSwatch's and the
     tooltip's hover work from ever running on a coarse pointer. Click,
     keyboard and every desktop behaviour are untouched: on (hover: hover) and
     (pointer: fine) this listener returns immediately.

     Evaluated per event, not cached, so a device that changes pointer
     capability - or Safari's Responsive Design Mode - is always correct. */
  function hoverlessPointer() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(hover: none), (pointer: coarse)').matches
    );
  }

  // Quick Add temporarily owns the same overlay stack. Its closed transition
  // restores the permanent card choice, including colours outside the hover cap.
  document.addEventListener('theme:card:quick-add-closed', function (event) {
    var card = event.target;
    var swatch = card && selectedSwatches.get(card);
    if (hoverlessPointer() && swatch && card.isConnected && card.contains(swatch)) selectColour(card, swatch);
  });

  ['mouseover', 'mouseenter'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        if (!hoverlessPointer()) return;
        var target = event.target;
        if (!target || !target.closest) return;
        if (!target.closest('.product-item .swatch__button')) return;
        event.stopImmediatePropagation();
      },
      true
    );
  });

  /* Delegated from the SWATCH BUTTON, not from the 18px link inside it.

     The tap target is <tooltip-component class="swatch__button">, measured
     live at 390 as 33 x 34; the <a class="swatch__link"> that paints the dot
     is only 18 x 18 and centred, so roughly 71% of the touch area resolves to
     the button's own padding. Binding to the link meant every tap that landed
     on that padding - which is most thumb taps - skipped this adapter
     entirely: document.elementFromPoint() at the button's padding returns
     tooltip-component.swatches, and closest('.swatch__link') is null there.

     The theme's own GridSwatch binds its click on the button, so those taps
     still moved the selected ring while syncTouchMedia() below never ran.
     On a touch device that is exactly the reported symptom: the ring moves,
     the photo does not, because the opaque hover-images layer is only
     suppressed from inside this adapter. Measured on the padding tap before
     this change: is-selected true, aria-pressed null,
     has-card-swatch-selection absent.

     The link keeps its real ?variant= href for no-JS navigation and keyboard
     activation; preventDefault still cancels that navigation whenever the tap
     actually originated inside the link. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var swatch = target.closest('.swatch__button');
    if (!swatch) return;

    var card = swatch.closest('.product-item');
    if (!card || !swatch.querySelector('.swatch__link')) return;

    event.preventDefault();
    selectColour(card, swatch);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    var target = event.target;
    if (!target || !target.closest) return;

    /* the "+N" control is the theme's own .swatch-limited div, given
       role="button"/tabindex in product-grid-item.liquid, so it needs explicit
       Enter/Space handling that a real <button> would have had for free. */
    var moreKey = target.closest('[data-swatch-more]');
    if (moreKey) {
      var holderKey = moreKey.closest('.product-item__swatches__holder');
      if (holderKey) {
        event.preventDefault();
        holderKey.classList.add('is-expanded');
        moreKey.setAttribute('aria-expanded', 'true');
        moreKey.hidden = true;
      }
      return;
    }

    var link = target.closest('.swatch__link');
    if (!link) return;
    var swatch = link.closest('.swatch__button');
    var card = link.closest('.product-item');
    if (!swatch || !card) return;
    event.preventDefault();
    selectColour(card, swatch);
  });

})();
